import { Loading, NotFound } from "@dgs/core";
import * as Sentry from "@sentry/react";
import { FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import { AppProviders } from "./AppProviders";
import { BlockPage } from "./blocks/BlocksPage";
import { Content } from "./content";
import { InitiateRegistrationPage } from "./InitiateRegistrationPage";
import { RegistrationPage } from "./registration/RegistrationPage";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const AppRoutes: FC = () => {
	return (
		<BrowserRouter>
			<AppProviders>
				<SentryRoutes>
					<Route element={<Content />}>
						<Route index element={<Loading />} />
						<Route path="blocks/:slug" element={<BlockPage />} />
						<Route path="initiate-registration/:guestId" element={<InitiateRegistrationPage />} />
						<Route path="registrations/*" element={<RegistrationPage />} />
						<Route path="*" element={<NotFound />} />
					</Route>
				</SentryRoutes>
			</AppProviders>
		</BrowserRouter>
	);
};
